import { render, staticRenderFns } from "./LicenceHistoryModel.vue?vue&type=template&id=cadd5334&"
import script from "./LicenceHistoryModel.vue?vue&type=script&lang=js&"
export * from "./LicenceHistoryModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports